import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'
import {useQuery} from '@github-ui/react-query'
import {
  fetchWithErrorHandling,
  parseJSONWithBetterErrors,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {sendStats} from '@github-ui/stats'
import {useEffect} from 'react'
import type {CIFinding} from './ci-findings-types'

type CIFindingsAPIResponse = {
  ciFindings: CIFinding[]
  checkRunId?: number
  checkSuiteId?: number
  pullRequestId?: number
  headSha?: string
}

export function useCIFindings({enabled = true}: {enabled?: boolean} = {}): {
  findings: CIFinding[]
  isLoading: boolean
  isError: boolean
} {
  const apiURL = usePageDataUrl(PageData.ciFindings)

  const {data, isLoading, isError} = useQuery({
    queryKey: ['ciFindings', apiURL],
    queryFn: async (): Promise<CIFinding[]> => {
      const response = await fetchWithErrorHandling(apiURL)
      const json = (await parseJSONWithBetterErrors(response)) as CIFindingsAPIResponse
      return json.ciFindings ?? []
    },
    staleTime: 30_000,
    retry: false,
    enabled,
  })

  useEffect(() => {
    if (isError) {
      sendStats({incrementKey: 'CI_FINDINGS_FETCH_ERROR'})
    }
  }, [isError])

  return {findings: data ?? [], isLoading, isError}
}
